import { Box, Heading, NumberInput, NumberInputField, Tooltip } from '@chakra-ui/react';
import { FC } from 'react';
import { useStore } from '../../../hooks/useStore';
import { shallow } from 'zustand/shallow';
import { AdElementText } from '@adflow/types';

type Props = {
  selectedElement: AdElementText;
};

const FontSizeInput: FC<Props> = ({ selectedElement }) => {
  const store = useStore(
    (state) => ({
      selectedElementId: state.selectedElementId,
      updateElementData: state.updateElementData,
    }),
    shallow,
  );

  const isDynamicFontSizeEnabled = selectedElement.data.dynamicFont.enabled;

  const handleFontSize = (fontSize: string): void => {
    const fontSizeValue: number = parseFloat(fontSize);

    const isValidFontSize = fontSizeValue > 1;

    store.updateElementData(selectedElement.id, {
      ...selectedElement.data,
      style: {
        ...selectedElement.data.style,
        fontSize: isValidFontSize ? fontSizeValue : 1,
      },
    });
  };

  const handleArrows = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    const { key, target } = event;
    if (key === 'ArrowUp' || key === 'ArrowDown') {
      handleFontSize((target as HTMLInputElement).value);
    }
  };

  return (
    <Box>
      <Heading fontSize="md" fontWeight="semibold">
        Font size
      </Heading>
      <Tooltip
        label="Disable auto fitting"
        isDisabled={!isDynamicFontSizeEnabled}
        placement="bottom"
        hasArrow
      >
        <NumberInput
          defaultValue={selectedElement.data.style.fontSize || undefined}
          size="sm"
          width={20}
          variant="outline"
          mt={2}
          precision={0}
          min={1}
          isDisabled={isDynamicFontSizeEnabled}
        >
          <NumberInputField
            data-test-id="font-size-input"
            onChange={(e) => handleFontSize(e.target.value)}
            onKeyUp={handleArrows}
            sx={{
              color: isDynamicFontSizeEnabled ? 'transparent' : 'inherit',
              _disabled: {
                cursor: 'text',
                _hover: {
                  borderColor: 'red.500',
                  borderWidth: '2px',
                },
              },
            }}
          />
        </NumberInput>
      </Tooltip>
    </Box>
  );
};

FontSizeInput.displayName = 'FontSizeInput';

export default FontSizeInput;
export type { Props as FontSizeInputProps };
